document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-marabu-slider]').forEach(slider=>{
    const slides=[...slider.querySelectorAll('[data-slide]')];
    if(!slides.length)return;
    const dots=[...slider.querySelectorAll('[data-dot]')];
    let i=0;
    const show=n=>{
      i=(n+slides.length)%slides.length;
      slides.forEach((s,j)=>s.classList.toggle('hidden',j!==i));
      dots.forEach((d,j)=>d.classList.toggle('is-active',j===i));
    };
    slider.querySelector('[data-prev]')?.addEventListener('click',()=>show(i-1));
    slider.querySelector('[data-next]')?.addEventListener('click',()=>show(i+1));
    dots.forEach((d,j)=>d.addEventListener('click',()=>show(j)));
    let timer;
    const start=()=>{clearInterval(timer);const ms=Number(slider.dataset.autoplay||0);if(slides.length>1&&ms>0)timer=setInterval(()=>show(i+1),ms)};
    start(); slider.addEventListener('mouseenter',()=>clearInterval(timer)); slider.addEventListener('mouseleave',start);
  });
  document.querySelectorAll('[data-marabu-menu]').forEach(menu=>{
    menu.addEventListener('click',()=>{const nav=menu.closest('.marabu-site-header')?.querySelector('[data-marabu-nav]');nav?.classList.toggle('is-open');menu.setAttribute('aria-expanded',nav?.classList.contains('is-open')?'true':'false')});
  });
  document.querySelectorAll('.filter-btn').forEach(b=>b.addEventListener('click',()=>{document.querySelectorAll('.filter-btn').forEach(x=>x.classList.remove('bg-primary','text-on-primary'));b.classList.add('bg-primary','text-on-primary')}));
});
